import { CardGoals as CardGoalsComponent } from "./CardGoals.component";


export const CardGoals = CardGoalsComponent;

